import { PropsWithChildren } from "react";
import {
  AppBarComponent,
  BreadcrumbBeforeItemRenderEventArgs,
  BreadcrumbComponent,
} from "@syncfusion/ej2-react-navigations";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import { useLocation } from "react-router-dom";
import { UclRouteObject } from "../../../utils/routes";
import classNames from "classnames";
import { utils } from "../../../";

export interface BreadcrumbSettings {
  uclRouteObject: UclRouteObject[];
  disabled?: boolean;
}
export interface AppHeaderComponentProps {
  appLogo?: React.ReactNode;
  appTitle?: React.ReactNode;
  breadcrumbSettings?: BreadcrumbSettings;
  onMenuClicked?: () => void;
  theme?: string;
  actions?: React.ReactNode;
}

const AppHeaderComponent: React.FC<
  AppHeaderComponentProps & PropsWithChildren
> = (props) => {
  const location = useLocation();

  const beforeItemRenderHandler = (
    args: BreadcrumbBeforeItemRenderEventArgs
  ) => {
    if (props.breadcrumbSettings?.uclRouteObject && args.item.text) {
      for (const child of props.breadcrumbSettings.uclRouteObject) {
        const route = utils.routes.findRouteByPath(child, args.item.text);

        if (route && !route?.showInSubNavigation) {
          args.cancel = true;
          break;
        }

        if (route && route?.label) {
          args.item.text = route.label;
          break;
        }
      }
    }
  };
  return (
    <div
      className={classNames(
        "ucl-app-header",
        props.theme ? `theme-${props.theme}` : ""
      )}
    >
      <AppBarComponent colorMode="Inherit">
        <div>
          {props.onMenuClicked && (
            <div className="ucl-app-header-menu">
              <ButtonComponent
                cssClass="e-inherit menu e-primary"
                iconCss="e-icons e-menu"
                isPrimary={true}
                onClick={props.onMenuClicked}
              />
            </div>
          )}
          {props.appLogo && (
            <div className="ucl-app-header-logo">{props.appLogo}</div>
          )}
          {props.appTitle && (
            <div className="ucl-app-header-title">{props.appTitle}</div>
          )}
          {props.breadcrumbSettings && (
            <div className="ucl-app-header-breadcrump">
              <BreadcrumbComponent
                disabled={props.breadcrumbSettings?.disabled}
                key={location.pathname}
                enableNavigation={true}
                url={location.pathname}
                beforeItemRender={beforeItemRenderHandler}
              />
            </div>
          )}
          <div className="ucl-app-header-actions">{props.actions}</div>
        </div>
        <div className="main-header-content">{props.children}</div>
      </AppBarComponent>
    </div>
  );
};
export const AppHeader = AppHeaderComponent;
export default AppHeader;
